import PropTypes from 'prop-types'
import classNames from 'classnames'

import s from './BoardsAlphabeticalFilter.module.css'

function BoardsAlphabeticalFilter({
  models = [],
  setFilter = () => {},
  activeFilter = '',
}) {
  const firstNameLetters = [
    ...new Set(models.map((m) => m.firstName.charAt(0))),
  ]
  const filters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ]
  return (
    <div className={s.container}>
      <button
        type="button"
        onClick={() => setFilter(null)}
        className={classNames(s.filter, {
          [s.filterActive]: activeFilter === null,
        })}
      >
        All
      </button>
      {filters.map((filter) => (
        <button
          key={filter}
          type="button"
          onClick={() => setFilter(filter)}
          className={classNames(
            s.filter,
            {
              [s.filterInactive]: !firstNameLetters.includes(filter),
            },
            {
              [s.filterActive]: activeFilter === filter,
            }
          )}
        >
          {filter}
        </button>
      ))}
    </div>
  )
}

BoardsAlphabeticalFilter.propTypes = {
  models: PropTypes.array,
  setFilter: PropTypes.func,
  activeFilter: PropTypes.string,
}

export default BoardsAlphabeticalFilter
